import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFilter } from "../../features/filter/filterSlice";
import { fetchTags } from "../../features/tags/tagsSlice";
import Tag from "./Tag";

export default function Tags() {
  const { tags } = useSelector((state) => state.tags);
  const { tags: filterTag, search, author } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);

  return tags?.length > 0 ? (
    <section>
      <div className="max-w-7xl flex justify-between  gap-2  mx-auto px-5 py-6 lg:px-0 ">
        <div className=" flex gap-2 border-b overflow-y-auto">
          {tags.map((tag) => (
            <Tag key={tag.id} title={tag.title} />
          ))}
        </div>
        {(!!filterTag?.length || !!search?.length || !!author?.length) && (
          <div>
            <div
              className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full cursor-pointer"
              onClick={() => dispatch(clearFilter())}
            >
              Clear Filter
            </div>
          </div>
        )}
      </div>
    </section>
  ) : null;
}
